/**
 * Success toast for resetUserMfa. The effect is invisible in the UI (the
 * directory forgets the user's methods), so both surfaces — the button and
 * the action-menu item — say it happened.
 */
export const USER_RESET_MFA_DONE_TITLE =
  "MFA reset — the user will re-register on next sign-in"
